export enum ProcedureTypes {
  // ChangeNOChanges = 1,
  // ChangeWITHCHangesHolder,
  // ChangeWITHChangesFlowExpansion,
  // ChangeWITHChangesFlowHolder,
  // HighNewSupply,
  // OutgoingCustomer,
  // HolderModification,
  // ChangeNOChanges_PWR,
  // ChangeWITHCHanges_PWR_Adm,
  // ChangeWITHChanges_PWR_Tec,
  // ChangeWITHChanges_PWR_Adm_Tec,
  // HighNewSupply_PWR,
  // OutgoingCustomer_PWR,
  // NewEngagement,
  // Drop_Supply_GAS,
  // Drop_Supply_PWR,
  // EngagementCancellation

  CambioSINCambios = 1,
  CambioCONCambios_Titular = 2,
  CambioCONCambios_Ampliacion_Caudal = 3,
  CambioCONCambios_Titular_y_Caudal = 4,
  Alta_Nuevo_Suministro = 5,
  ClienteSaliente = 6,
  Modificacion_Titular = 7,
  CambioSINCambios_PWR = 8,
  CambioCONCambios_PWR_Adm = 9,
  CambioCONCambios_PWR_Tec = 10,
  CambioCONCambios_PWR_Adm_y_Tec = 11,
  Alta_Nuevo_Suministro_PWR = 12,
  ClienteSaliente_PWR = 13,
  Nueva_Contratacion = 14,
  Baja_Suministro_GAS = 15,
  Baja_Suministro_PWR = 16,
  Anulacion_Contratacion_GAS = 17,
  Modificacion_PWR_Adm = 18,
  Modificacion_PWR_Tec = 19,
  Modificacion_PWR_Adm_y_Tec = 20,
  Reclamacion_GAS_Tramitacion = 21,
  Reclamacion_GAS_Factura = 22,
  Reclamacion_GAS_CUPS = 23,
  Reclamacion_PWR_Tramitacion = 24,
  Reclamacion_PWR_Factura = 25,
  Reclamacion_PWR_CUPS = 26,
  NuevaContratacionAcceso_GAS = 27,
  Modificacion_GAS_Adm = 28,
  Modificacion_GAS_Tec = 29,
  TraspasoCUR = 30,
  TraspasoCOR = 31,
  NotificacionCambios = 32,
  NotificacionModificacionDatos = 33,
  Desistimiento_PWR = 34,
  Desistimiento_GAS = 35,
  Actuacion_GAS = 36,
  Reposicion = 37,
  ReposicionPasiva = 38,
  Modificacion_GAS_Adm_y_Tec = 39,
  Modificacion_Titular_PWR = 40,
  CorteSuministroGas = 41,
  ReengancheSuministroGas = 42,
  CorteSuministroPWR = 43,
  Modificacion_Titular_y_Tec = 44,
  Modificacion_Titular_y_Tec_PWR = 45,
  DesistimientoPasivo_GAS = 46,
  DesistimientoPasivo_PWR = 47,
  Reposicion_GAS = 48,
  ReposicionPasiva_GAS = 49
}
